import { render, staticRenderFns } from "./cam_test.vue?vue&type=template&id=3165f438"
import script from "./cam_test.js?vue&type=script&lang=js&external"
export * from "./cam_test.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports